import styled, { css } from 'styled-components';

const menuItemStyles = css`
  .menu-item--parent-link {
    font-weight: 600;
    display: flex;
    align-items: center;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (min-width: 1240px) {
    &.has-child {
      &:before {
        content: '';
        position: absolute;
        margin: auto;
        width: 20px;
        height: 20px;
        transform: rotate(225deg);
        -webkit-transform: rotate(225deg);
        -moz-transform: rotate(225deg);
        -o-transform: rotate(225deg);
        border: none;
        -ms-transform: rotate(225deg);
        border-right: 1px solid #e9eff2;
        border-bottom: 1px solid #e9eff2;
        background: transparent;
        z-index: 1000;
        margin-left: 35px;
        opacity: 0;
        visibility: hidden;
        margin-top: 50px;
        transition: all 0.25s ease-out;
      }

      &:after {
        content: '';
        position: absolute;
        margin: auto;
        border: none;
        z-index: 2147483647 !important;
        margin-left: 31px;
        opacity: 0;
        visibility: hidden;
        margin-top: -33px;
        transition: all 0.25s ease-out;
        width: 0;
        height: 0;
        border-left: 14px solid transparent;
        border-right: 14px solid transparent;
        border-bottom: 14px solid white;
      }
      &:hover,
      &:focus-within {
        &:before {
          opacity: 1;
          visibility: visible;
          margin-top: 70px;
        }
        &:after {
          opacity: 1;
          visibility: visible;
          margin-top: -13px;
        }
        .mega-menu,
        .simple-menu {
          visibility: visible;
          opacity: 1;
          margin-top: 0;
          pointer-events: auto;
        }
      }
    }
  }

  @media (max-width: 1450px) {
    &.has-child {
      &:hover {
        &:before {
          margin-top: 46px;
        }
      }
    }
  }
`;

const MenuItemContainer = styled.li`
  ${({ type }) =>
    type && (type.includes('simple-menu') || type.includes('menu')) && menuItemStyles};

  padding: 0 16px;
  display: ${({ type }) => (type && type.includes('mobile-view') ? 'none' : 'inline-block')};
  vertical-align: middle;
  padding: 0 17px;

  .anticon-caret-down {
    display: inline-block;
    margin-left: 4px;
  }

  .anticon-caret-up {
    display: none;
  }

  .menu-item--parent-link,
  a {
    font-family: Sofia Pro;
    font-size: 16px;
    line-height: 80px;
    transition: none;
    cursor: pointer;
  }

  @media (max-width: 1450px) {
    .menu-item--parent-link,
    a {
      color: var(--neutral-7) !important;
      font-size: 14px;
      line-height: 56px;
    }
  }

  @media (max-width: 1240px) {
    display: inline-block;
    padding: 0 !important;
    width: 100%;
    height: ${({ isMenuOpened }) => (isMenuOpened ? 'auto' : '55px')};

    .anticon-caret-up {
      display: ${({ isMenuOpened }) => (isMenuOpened ? 'inline-block' : 'none')};
      margin-left: 4px;
    }
    .anticon-caret-down {
      display: ${({ isMenuOpened }) => (isMenuOpened ? 'none' : 'inline-block')};
      margin-left: 4px;
    }

    .anticon {
      float: right;
      margin-left: 3px;
    }

    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      position: relative;

      i {
        font-size: 10px;
        position: absolute;
        right: 31px;
        top: 19px;
      }
    }
  }

  @media (max-width: 680px) {
    display: ${({ type }) => (type && type.includes('desktop-view') ? 'none' : 'inline-block')};
  }
`;

export { MenuItemContainer };
